// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"oK-z","carouselContainer":"pK-z"};